import React from 'react';

import PropTypes from 'prop-types';
import { RadioGroup, Notification, Spacer } from '@telus-uds/components-web';

import { useLocalizedStringsContext } from '../../../../../../context/LocalizedStringsContext';

const TankMaterial = ({ dataField, setDataField, error }) => {
  const {
    iotOrderDetailsSection: { tankMaterial },
    modalForm: { fieldRequiredMessage }
  } = useLocalizedStringsContext();

  const fieldOptions = ['Steel', 'Stainless Steel', 'Poly', 'Other'];
  const fieldHasError = error && !dataField.valueTankMaterial;
  const otherFieldHasError =
    error &&
    dataField.valueTankMaterial === 'Other' &&
    !dataField.valueTankMaterialOther;

  // Convert options to RadioGroup items format
  const radioItems = fieldOptions.map(option => ({
    label: option,
    id: option
  }));

  return (
    <>
    <Spacer space={4} />
      <RadioGroup
        legend={tankMaterial}
        items={radioItems}
        checkedId={dataField.valueTankMaterial || null}
        onChange={(value) => setDataField({
          ...dataField,
          valueTankMaterial: value
        })}
        name="tank-material"
        validation={fieldHasError ? 'error' : undefined}
        feedback={fieldHasError ? fieldRequiredMessage : undefined}
      />
      {dataField.valueTankMaterial === 'Other' && (
        <input
          type="text"
          className={`tank-details__other-product ${otherFieldHasError &&
            'error'}`}
          placeholder="material.."
          value={dataField.valueTankMaterialOther}
          onChange={e =>
            setDataField({
              ...dataField,
              valueTankMaterialOther: e.target.value
            })
          }
        />
      )}
      {otherFieldHasError && (
        <div style={{ marginTop: '5px' }}>
          <Notification variant={{ validation: 'error' }}>
            {fieldRequiredMessage}
          </Notification>
        </div>
      )}
      <Spacer space={2} />
    </>
  );
};

TankMaterial.propTypes = {
  dataField: PropTypes.shape({
    valueTankNumber: PropTypes.string,
    valueTankName: PropTypes.string,
    valueTankProduct: PropTypes.string,
    valueTankProductOther: PropTypes.string,
    valueTankType: PropTypes.string,
    valueTankHeight: PropTypes.string,
    valueTankLength: PropTypes.string,
    valueTankCapacity: PropTypes.string,
    valueTankMaterial: PropTypes.string,
    valueTankMaterialOther: PropTypes.string,
    valueTankSensorType: PropTypes.string,
    valueTankPortSize: PropTypes.string,
    valueTankOptionalStand: PropTypes.string
  }).isRequired,
  setDataField: PropTypes.func.isRequired,
  error: PropTypes.string.isRequired
};

export default TankMaterial;
